export default __webpack_public_path__ + "static/media/weather.9f6b6cd4.svg";